import icons from "url:../../img/icons.svg";
import View from "./View.js";

class addRecipeView extends View {}

export default new addRecipeView();
